module.exports = __webpack_public_path__ + "d46f4f7e4628024565e63481980a6b71.pdf";